import { Alert } from '@mui/material'
import { type TError } from '../redux/api/types'

interface IErrorMessage {
  error: TError
}

const ErrorMessage = ({ error }: IErrorMessage) => {
  let msg = ''
  let errs: string[] = []

  if (error) {
    if ('status' in error) {
      const errorData = error.data
      if ('message' in errorData) {
        msg = errorData.message
      }
    } else {
      msg = error.message ?? ''
    }
  }

  if (error) {
    if ('status' in error) {
      const errorData = error.data
      if ('errors' in errorData) {
        const errsData = errorData.errors
        errs = Object.values(errsData)
      }
    }
  }
  return (
        <>
            {error && (
                <Alert
                    role="alert"
                    aria-live="polite"
                    icon={false}
                    severity="error"
                    sx={{
                      mt: '34px'
                    }}
                >
                    {msg && msg}
                    {errs?.map((item, index) => <>{msg !== item && <p key={index}>{item}</p>}</>)}
                </Alert>
            )}
        </>
  )
}

export default ErrorMessage
